// Profile images for 2026
const profileImages = {};

// Import all profile images dynamically
const importAll = (r) => {
  r.keys().forEach((key) => {
    // Extract filename without extension (e.g., "04" or "23b" from "./04.jpg" or "./23b.jpg")
    const filename = key.replace('./', '').replace(/\.(jpg|png)$/, '');
    profileImages[filename] = r(key);
  });
};

importAll(require.context('../assets/profile/2026', false, /\.(jpg|png)$/));

// Get profile image for a desk number and seat index
// seatIndex: 0 for first seat, 1 for second seat (uses "b" suffix)
export const getProfileImage = (deskNumber, seatIndex = 0) => {
  // Normalize desk number to string without leading zeros for lookup
  const deskStr = String(deskNumber).replace(/^0+/, '') || '0';
  // For padded lookup (some images use 04 instead of 4)
  const paddedDesk = String(deskNumber).padStart(2, '0');

  let imageKey;
  if (seatIndex === 0) {
    // First seat: try both formats (04 and 4)
    imageKey = profileImages[paddedDesk] || profileImages[deskStr];
  } else {
    // Second seat: add "b" suffix
    imageKey = profileImages[paddedDesk + 'b'] || profileImages[deskStr + 'b'];
  }

  return imageKey || null;
};

export default profileImages;
